module.exports = __webpack_public_path__ + "img/pantalla-final.4891ac71.png";